import { useState, useEffect } from "react";

const useWindowSize = () => {
	const getSize = () => ({
		width: window.innerWidth,
		height: window.innerHeight
	});

	const [windowSize, setWindowSize] = useState(getSize);

	document.documentElement.style.setProperty('--ViewHeight', `${windowSize.height}px`);

	useEffect(() => {
		const handleResize = () => {
			setWindowSize(getSize());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowSize;
}
export default useWindowSize;